// extracted by mini-css-extract-plugin
export var externalLink = "_bi-0";
export var internalLinkLabel = "_bi-1";